import { BrowserCacheLocation, Configuration, LogLevel } from "@azure/msal-browser";
import { EnvironmentConfigService } from "./shared/services/environment-config.service";

export const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

const openIdConfig = EnvironmentConfigService.getOpenIdConfig(); // Get OpenID config

export const msalConfig: Configuration = {
  auth: {
    clientId: openIdConfig.clientId, // Use clientId from OpenIdService
    authority: openIdConfig.authority,
    redirectUri: '/', // Points to window.location.origin by default. You must register this URI on Azure portal/App Registration.
    postLogoutRedirectUri: '/', // Points to window.location.origin by default.
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: isIE, // Set this to "true" if you are having issues on IE11 or Edge. Remove this line to use Angular Universal
  },
  system: {
    /**
     * Below you can configure MSAL.js logs. For more information, visit:
     * https://docs.microsoft.com/azure/active-directory/develop/msal-logging-js
     */
    loggerOptions: {
      loggerCallback(logLevel: LogLevel, message: string) {
      },
      logLevel: LogLevel.Error,
      piiLoggingEnabled: false
    }
  }
}

export const loginRequest = {
  scopes: []
}

/**
* An optional silentRequest object can be used to achieve silent SSO
* between applications by providing a "loginHint" property (such as a username). For more, visit:
* https://learn.microsoft.com/en-us/azure/active-directory/develop/msal-js-sso#sso-between-different-apps
* If you do not receive the username claim in ID tokens, see also:
* https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/FAQ.md#why-is-getaccountbyusername-returning-null-even-though-im-signed-in
*/
export const silentRequest = {
  scopes: [],
  loginHint: "example@domain.net"
};
